module.exports = __webpack_public_path__ + "static/media/bg-lake-mobile.d0f26ef3.jpg";